import {
  ApplicationInsights,
  DistributedTracingModes,
} from "@microsoft/applicationinsights-web";
import { initCollector } from "./supportInfoCollector";

(function (drupalSettings) {
  if (
    "zebInsights" in drupalSettings &&
    (!("requestHistoryDisabled" in drupalSettings.zebInsights) ||
      drupalSettings.zebInsights.requestHistoryDisabled != "true")
  ) {
    initCollector();
  }

  if (
    "zebInsights" in drupalSettings &&
    (("insightsConnectionString" in drupalSettings.zebInsights &&
      drupalSettings.zebInsights.insightsConnectionString &&
      String(drupalSettings.zebInsights.insightsConnectionString).length > 0) ||
      ("insightsKey" in drupalSettings.zebInsights &&
        drupalSettings.zebInsights.insightsKey &&
        String(drupalSettings.zebInsights.insightsKey).length > 0))
  ) {
    let config = {
      disableCookiesUsage: true,
      autoTrackPageVisitTime: true,
      disableFetchTracking: false,
      distributedTracingMode: DistributedTracingModes.W3C,
      enableAjaxPerfTracking: true,
      enableAutoRouteTracking: true,
      enableCorsCorrelation: false,
      enableRequestHeaderTracking: true,
      enableResponseHeaderTracking: true,
    };
    if (
      "insightsConnectionString" in drupalSettings.zebInsights &&
      drupalSettings.zebInsights.insightsConnectionString &&
      String(drupalSettings.zebInsights.insightsConnectionString).length > 0
    ) {
      config["connectionString"] =
        drupalSettings.zebInsights.insightsConnectionString;
    } else if (
      "insightsKey" in drupalSettings.zebInsights &&
      drupalSettings.zebInsights.insightsKey &&
      String(drupalSettings.zebInsights.insightsKey).length > 0
    ) {
      config["instrumentationKey"] = drupalSettings.zebInsights.insightsKey;
    }

    if (
      "insightsProxyKey" in drupalSettings.zebInsights &&
      drupalSettings.zebInsights.insightsProxyKey &&
      String(drupalSettings.zebInsights.insightsProxyKey).length > 0
    ) {
      config["customHeaders"] = [
        {
          header: "X-Zeb-Insights-Proxy-Key",
          value: drupalSettings.zebInsights.insightsProxyKey,
        },
      ];
    }

    let appInsights = new ApplicationInsights({
      config: config,
    });

    appInsights.loadAppInsights();
    appInsights.addTelemetryInitializer((envelope) => {
      envelope.tags["ai.cloud.role"] = "browser";
      envelope.tags["ai.cloud.roleInstance"] = "browser";
    });

    let appName = null;
    if (window.zebDshAppFrameConfig && window.zebDshAppFrameConfig.appName) {
      appName = String(window.zebDshAppFrameConfig.appName);
    }

    if ("traceparentTraceId" in drupalSettings.zebInsights) {
      appInsights.context.telemetryTrace.traceID =
        drupalSettings.zebInsights.traceparentTraceId;
    }
    if ("traceparentParentId" in drupalSettings.zebInsights) {
      appInsights.context.telemetryTrace.parentID =
        drupalSettings.zebInsights.traceparentParentId;
      let data = {
        type: "HTTP",
        target: appName == null ? "portal" : appName,
        name: document.location.href,
        responseCode: 200,
        method: "GET",
        id: drupalSettings.zebInsights.traceparentParentId,
        properties: { component: "HTTP" },
      };
      const performanceNavigationTimings =
        window.performance.getEntriesByType("navigation");
      if (
        performanceNavigationTimings &&
        performanceNavigationTimings.length > 0
      ) {
        const performanceNavigationTiming = performanceNavigationTimings[0];
        if (
          performanceNavigationTiming &&
          "responseEnd" in performanceNavigationTiming &&
          "requestStart" in performanceNavigationTiming
        ) {
          const durationMillis =
            performanceNavigationTiming["responseEnd"] -
            performanceNavigationTiming["requestStart"];
          data["duration"] = durationMillis;
        }
      }
      appInsights.trackDependencyData(data);
    }
    if (appName == null) {
      appInsights.trackPageView();
    } else {
      appInsights.trackPageView({ name: appName });
    }

    window.appInsights = appInsights;
  } else {
    console.warn("key for insights not available");
  }

  if (
    "zebInsights" in drupalSettings &&
    "matomoEnabled" in drupalSettings.zebInsights &&
    drupalSettings.zebInsights.matomoEnabled == "true"
  ) {
    if (!("_mtm" in window)) {
      window._mtm = [];
    }
    (function () {
      var _mtm = window._mtm;
      _mtm.push({ "mtm.startTime": new Date().getTime(), event: "mtm.Start" });
      var d = document,
        g = d.createElement("script"),
        s = d.getElementsByTagName("script")[0];
      g.type = "text/javascript";
      g.async = true;
      g.defer = true;
      g.src = "https://analytics.kopfkunst.net/js/container_lCK9VOVs.js";
      s.parentNode.insertBefore(g, s);
    })();
  }
})(drupalSettings);
